import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { GRID2D_GALLERY__image_master } from './GRID2D_GALLERY__image_master';
import { GRID2D_GALLERY__image_neigbours } from './GRID2D_GALLERY__image_neigbours';

interface PROPS {
  grid2d: DTO__grid2d;
}

export function GRID2D_GALLERY__float({ grid2d }: PROPS) {
  return (
    <div className="relative size-full bg-component">
      <GRID2D_GALLERY__image_master />
      <GRID2D_GALLERY__image_neigbours {...{ grid2d }} />
    </div>
  );
}
